import { TranslateService } from "@ngx-translate/core";

import { subscriptionNameKey } from "../../../../helpers/subscription-i18n";

const constructPageTitle = (translate: TranslateService, pageURL: string): Promise<string> => {
  const productType = pageURL.substring(pageURL.lastIndexOf("/") + 1);
  const key = subscriptionNameKey(productType);
  if (!key) return Promise.resolve(productType);

  return new Promise((resolve) => {
    translate.get(key).subscribe(resolve);
  });
};

export default constructPageTitle;
